import { PathsApiCharacterAssetsGetParametersQueryCategory } from "@apis/generated/openapi";
import { listCharacterAssets, type CharacterAssetRecord } from "@apis/http/api";
import type { ScrollPageResult } from "@hooks/useScrollLoad";
import type { CharacterType } from "../librarySlice";

/** Library CharacterType → 接口 category 枚举映射 */
export const characterTypeToCategory: Record<CharacterType, PathsApiCharacterAssetsGetParametersQueryCategory> = {
  model: PathsApiCharacterAssetsGetParametersQueryCategory.MODEL,
  animal: PathsApiCharacterAssetsGetParametersQueryCategory.ANIMAL,
};

export interface CharacterListParams {
  category: PathsApiCharacterAssetsGetParametersQueryCategory;
}

/**
 * 角色资产分页拉取器，供 Library 列表与各处选择弹窗（如视频复刻选模特）共用，
 * 与 useScrollLoad 的 fetcher 协议对齐。
 */
export const fetchCharactersPage = async ({
  category,
  pageNo,
  pageSize,
}: CharacterListParams & {
  pageNo: number;
  pageSize: number;
}): Promise<ScrollPageResult<CharacterAssetRecord>> => {
  const response = (await listCharacterAssets({ category, pageNo, pageSize })) as
    | {
        data?: CharacterAssetRecord[];
        pageNo?: number;
        pageSize?: number;
        total?: number;
      }
    | undefined;
  const data = response?.data ?? [];
  return {
    data,
    pageNo: Number(response?.pageNo ?? pageNo),
    pageSize: Number(response?.pageSize ?? pageSize),
    total: Number(response?.total ?? data.length),
  };
};
